// extracted by mini-css-extract-plugin
export default {"dark":"Skeleton_dark__BgHxd","light":"Skeleton_light__nh1Pf","skeleton":"Skeleton_skeleton__vulMF","skeleton_loading":"Skeleton_skeleton_loading__RqYyC"};